import React, { Component } from 'react';
import './index.css';

export class BlankLayout extends Component {
	render() {
		return (
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					alignContent: 'center',
					height: '100%',
					position: 'relative',
					flexWrap: 'wrap',
					backgroundColor: 'white'
				}}
			>
				{this.props.children}
			</div>
		);
	}
}

export default BlankLayout;
